async function LoadingData(apiCall: any) {
    let $loadingBox: any = document.getElementById('loadingBox');
    try {
        const response = await apiCall();
        return response;
    } catch (error) {
        console.error(error);
    } finally {
        $loadingBox.style.display = 'none';
    }
}

export default LoadingData;
